import React, { useEffect, useState } from "react";
import "./oferta.scss";
import Menu from "../../Components/General/Menu/Menu";
import Footer from "../../Components/General/Footer/Footer";
import { useLocation } from "react-router-dom";
const OfertaPage = () => {
  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo(0, 0);
    }, [pathname]);

    return null;
  };
  const [activeTab, setActiveTab] = useState("russian");

  const russianText = (
    <div className="oferta-content">
      <h1>
        ПУБЛИЧНАЯ ОФЕРТА (ОБЩИЕ УСЛОВИЯ ДОГОВОРА) НА ОКАЗАНИЕ ТЕЛЕМАТИЧЕСКИХ
        УСЛУГ СВЯЗИ
      </h1>

      <p>
        Настоящий документ, в соответствии со статьей 398 Гражданского кодекса
        Республики Таджикистан, является официальным предложением Общества с
        ограниченной ответственностью «Нет Солюшенс», ИНН 020047495, юридический
        адрес: Республика Таджикистан, г. Душанбе, ул. Т. Пулоди, 41 (далее —
        Оператор), определяющим общие условия предоставления телематических и
        сопутствующих услуг физическим и юридическим лицам.
      </p>

      <p>
        Принятие настоящей оферты физическим лицом (далее — Клиент) посредством
        заполнения анкеты клиента и подписания отдельного бланка договора либо
        фактического начала пользования услугами означает полное и
        безоговорочное согласие Клиента со всеми нижеизложенными условиями.
      </p>

      <h2>1. ПРЕДМЕТ ДОГОВОРА</h2>

      <p>
        1.1. Оператор обязуется предоставить Клиенту телематические, IPTV и иные
        информационные услуги в объеме и перечне, выбранных Клиентом в
        соответствии с действующими тарифами Оператора, а Клиент обязуется
        принять услуги и оплатить их стоимость согласно установленным тарифам.
      </p>

      <p>1.2. В состав предоставляемых услуг входят:</p>

      <p>предоставление каналов передачи данных;</p>
      <p>телематические услуги связи;</p>
      <p>услуга IPTV;</p>
      <p>доступ к информационным ресурсам глобальной сети Интернет;</p>
      <p>услуга по подключению объекта Клиента к сети Интернет;</p>
      <p>
        услуга «облачное видеонаблюдение (cloud video surveillance)»,
        предусматривающая предоставление Оператором возможности хранения,
        доступа и управления видеозаписями в облачной среде;
      </p>
      <p>предоставление телематического оборудования.</p>

      <h2>2. ПРАВА И ОБЯЗАННОСТИ СТОРОН</h2>

      <h3>2.1. Обязанности Оператора:</h3>
      <p>
        Обеспечить подключение Клиента к сети в установленный срок после
        подтверждения заявки Клиента;
      </p>
      <p>
        Предоставлять заказанные и оплаченные услуги в соответствии с условиями
        настоящей оферты;
      </p>
      <p>
        Поддерживать работоспособность оборудования и сетей связи, за
        исключением случаев, указанных в разделе «Форс-мажор»;
      </p>
      <p>
        Сохранять конфиденциальность персональных данных Клиента, за исключением
        случаев, предусмотренных законодательством Республики Таджикистан;
      </p>
      <p>
        Уведомлять Клиента об изменениях тарифов или условий обслуживания не
        менее чем за 15 (пятнадцать)дней до вступления изменений в силу
        посредством размещения информации на сайте{" "}
        <a href="www.nets.tj">www.nets.tj</a> и/или путем направления
        SMS-сообщения.
      </p>

      <h3>2.2. Права Оператора:</h3>
      <p>
        Временно приостанавливать предоставление услуг для проведения
        профилактических или технических работ с предварительным уведомлением на
        сайте;
      </p>
      <p>Приостанавливать доступ Клиента к сети в случае неплатежей;</p>
      <p>
        Вносить изменения в тарифы и действующие условия обслуживания с
        предварительным уведомлением;
      </p>
      <p>
        Прекращать предоставление услуг в случае нарушения условий оферты
        Клиентом.
      </p>

      <h3>2.3. Обязанности Клиента:</h3>
      <p>
        Своевременно оплачивать стоимость услуг в соответствии с условиями
        оферты;
      </p>
      <p>
        Незамедлительно уведомлять Оператора об изменении персональных данных,
        адреса или номера телефона;
      </p>
      <p>
        Бережно обращаться с арендованным оборудованием и возвращать его при
        прекращении услуг;
      </p>
      <p>Использовать услуги исключительно в законных целях;</p>
      <p>
        Воздерживаться от передачи незаконной, оскорбительной или вредоносной
        информации.
      </p>

      <h3>2.4. Права Клиента:</h3>
      <p>
        Запрашивать у Оператора письменную информацию о произведенных расчетах;
      </p>
      <p>
        Приостанавливать предоставление услуг на срок до 3 (трех) месяцев при
        письменном уведомлении Оператора;
      </p>
      <p>
        Приобретать арендованное оборудование или становиться его владельцем
        после полной оплаты его стоимости.
      </p>

      <h2>3. СТОИМОСТЬ УСЛУГ И ПОРЯДОК РАСЧЕТОВ</h2>

      <p>
        3.1. Стоимость услуг устанавливается в соответствии с действующими
        тарифами Оператора, опубликованными на сайте{" "}
        <a href="www.nets.tj">www.nets.tj</a>.
      </p>

      <p>3.2. Оплата может производиться следующими способами:</p>
      <p>наличными в кассу Оператора;</p>
      <p>безналичным переводом на расчетный счет Оператора;</p>
      <p>
        электронными платежными средствами (мобильный банкинг, электронные
        кошельки и др.).
      </p>

      <p>3.3. Расчетный период — календарный месяц.</p>

      <p>
        3.4. При отсутствии денежных средств на балансе Клиента Оператор вправе
        приостановить предоставление услуг.
      </p>

      <p>
        3.5. Клиент может воспользоваться услугой «обещанный платеж» на
        условиях, указанных на сайте Оператора.
      </p>

      <p>3.6. Все цены указаны в национальной валюте (сомони) с учетом НДС.</p>

      <h2>4. ПОРЯДОК ИЗМЕНЕНИЯ И ПРЕКРАЩЕНИЯ ДОГОВОРА</h2>

      <p>
        4.1. Все изменения к настоящей оферте вступают в силу с момента
        публикации новой версии на сайте <a href="www.nets.tj">www.nets.tj</a>.
      </p>

      <p>
        4.2. Клиент вправе прекратить получение услуг путем подачи письменного
        заявления.
      </p>

      <p>
        4.3. Оператор вправе прекратить предоставление услуг в случае
        неисполнения Клиентом условий оферты.
      </p>

      <p>
        4.4. Если Клиент не согласен с изменениями тарифов, он должен направить
        письменное уведомление в течение 5 (пяти) дней. В противном случае
        оферта считается принятой.
      </p>

      <h2>5. ОТВЕТСТВЕННОСТЬ СТОРОН</h2>

      <p>
        5.1. За неисполнение или ненадлежащее исполнение обязательств Стороны
        несут ответственность в соответствии с действующим законодательством
        Республики Таджикистан.
      </p>

      <p>
        5.2. Клиент несет личную ответственность за содержание передаваемой
        информации, а также за использование выделенного ему IP-адреса.
      </p>

      <p>
        5.3. За просрочку платежа начисляется пеня в размере 0,5% от суммы долга
        за каждый день просрочки, начиная со следующего дня после установленного
        срока оплаты.
      </p>

      <h2>6. ФОРС-МАЖОР</h2>

      <p>
        6.1. Стороны освобождаются от ответственности, если исполнение
        обязательств стало невозможным вследствие обстоятельств непреодолимой
        силы (пожар, стихийное бедствие, война, действия государственных органов
        и др.).
      </p>

      <p>
        6.2. Сторона, оказавшаяся под влиянием таких обстоятельств, обязана в
        течение 15 дней уведомить другую сторону о наступлении или прекращении
        таких обстоятельств.
      </p>

      <h2>7. РАЗРЕШЕНИЕ СПОРОВ</h2>

      <p>
        7.1. Все споры и разногласия между Сторонами разрешаются путем
        переговоров.
      </p>

      <p>
        7.2. В случае недостижения соглашения спор подлежит рассмотрению в
        судебном порядке в соответствии с законодательством Республики
        Таджикистан.
      </p>

      <h2>8. ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ</h2>

      <p>
        8.1. Условия оказания дополнительных услуг, не указанных в настоящей
        оферте, могут определяться отдельными соглашениями.
      </p>

      <p>
        8.2. Гарантийный срок на оборудование, предоставляемое Оператором,
        составляет 6 (шесть) месяцев.
      </p>

      <p>
        8.3. Оператор вправе в случае изменения законодательства или
        обязательных тарифов внести соответствующие изменения в оферту, уведомив
        Клиентов не менее чем за 5 (пять) дней.
      </p>

      <p>
        8.4. Принимая настоящую оферту, Клиент выражает согласие на обработку
        своих персональных данных и получение информационных и маркетинговых
        сообщений от Оператора.
      </p>

      <p>
        8.5. Вся информация о тарифах, ценах и условиях обслуживания размещается
        на сайте <a href="www.nets.tj">www.nets.tj</a> и указывается в
        подписанном Клиентом бланке договора.
      </p>

      <h2>9. СРОК ДЕЙСТВИЯ ОФЕРТЫ</h2>

      <p>
        9.1. Настоящая оферта является бессрочной и действует до публикации
        новой версии на сайте <a href="www.nets.tj">www.nets.tj</a>.
      </p>

      <p>
        9.2. Принятие оферты посредством подписания бланка договора или начала
        использования услуг означает полное и безусловное согласие Клиента со
        всеми изложенными условиями.
      </p>

      <p>
        ООО «Нет Солюшенс»
        <br />
        ИНН: 020047495
        <br />
        Республика Таджикистан, г. Душанбе, ул. Т. Пулоди, 41
        <br />
        Сайт: <a href="www.nets.tj">www.nets.tj</a>
        <br />
        Email: <a href="mailto:info@nets.tj">info@nets.tj</a>
      </p>
    </div>
  );

  const tajikText = (
    <div className="oferta-content">
      <h1>
        ПЕШНИҲОДИ УМУМИИ ШАРТНОМА (ОФЕРТА) ОИД БА ХИЗМАТРАСОНИҲОИ ТЕЛЕМАТИКИИ
        АЛОҚА
      </h1>

      <p>
        Ин ҳуҷҷат тибқи моддаи 398 Кодекси граждании Ҷумҳурии Тоҷикистон
        пешниҳоди расмии Ҷамъияти дорои масъулияти маҳдуди «Нет Солюшенс», РМА
        020047495, суроғаи ҳуқуқӣ: Ҷумҳурии Тоҷикистон, ш. Душанбе, кӯч. Т.
        Пулодӣ 41 (минбаъд — Оператор) мебошад, ки шароити умумии пешниҳоди
        хизматрасониҳои телематикӣ ва алоқамандро барои шахсони воқеӣ ва ҳуқуқӣ
        муайян менамояд.
      </p>

      <p>
        Қабули ин оферта аз ҷониби шахси воқеӣ (минбаъд — Муштарӣ) тавассути пур
        кардани анкетаи муштарӣ ва имзои бланки шартномаи алоҳида, ё оғози
        истифодаи хизматҳо, маънои розигии пурра ва беэътирози ӯ бо ҳамаи
        шартҳои зеринро дорад.
      </p>

      <h2>1. МАТЛАБИ ШАРТНОМА</h2>

      <p>
        1.1. Оператор ӯҳдадор мешавад ба Муштарӣ хизматрасониҳои телематикӣ,
        IPTV ва дигар хизматҳои иттилоотиро мутобиқи феҳрист ва ҳаҷми
        интихобнамудаи Муштарӣ, ки дар нархномаи амалкунандаи Оператор нишон
        дода шудаанд, пешниҳод намояд, ва Муштарӣ ӯҳдадор мешавад хизматҳоро
        қабул ва арзиши онҳоро тибқи нархнома пардохт намояд.
      </p>

      <p>1.2. Ба доираи хизматҳо дохил мешаванд:</p>

      <p>пешниҳоди каналҳои интиқоли маълумот;</p>
      <p>хизматрасониҳои телематикӣ;</p>
      <p>хизматрасонии IPTV;</p>
      <p>дастрасӣ ба захираҳои иттилоотии шабакаи ҷаҳонии Интернет;</p>
      <p>хизматрасонии пайваст намудани объекти Муштарӣ ба шабакаи Интернет;</p>
      <p>
        хизматрасонии “видеоназорат” (cloud video surveillance), ки дар он
        Оператор имконияти нигоҳдорӣ, дастрасӣ ва идоракунии сабтҳои видеоиро
        тавассути абрӣ таъмин менамояд.
      </p>
      <p>пешниҳоди таҷҳизоти телематикӣ</p>

      <h2>2. ҲУҚУҚ ВА ӮҲДАДОРИҲОИ ТАРАФҲО</h2>

      <h3>2.1. Ӯҳдадориҳои Оператор:</h3>
      <p>
        Дар муҳлати муқаррарнамуда пас аз тасдиқи дархости Муштарӣ дастрасии ӯро
        ба шабака таъмин намояд;
      </p>
      <p>
        Хизматрасониҳои дархостшуда ва пардохтшударо мутобиқи шартҳои оферта
        пешниҳод кунад;
      </p>
      <p>
        Коршоямии таҷҳизот ва шабакаҳои алоқаи худро таъмин намояд, ба истиснои
        ҳолатҳои дар боби «Форс-мажор» зикршуда;
      </p>
      <p>
        Маълумоти шахсии Муштариро махфӣ нигоҳ дорад, ба ҷуз ҳолатҳои
        пешбининамудаи қонунгузории Ҷумҳурии Тоҷикистон;
      </p>
      <p>
        Дар бораи тағйирот дар нархнома ё шартҳои хизматрасонӣ на камтар аз 15
        (понздаҳ) рӯз қабл тавассути сомонаи{" "}
        <a href="www.nets.tj">www.nets.tj</a> ё СМС паёмак огоҳ намояд.
      </p>

      <h3>2.2. Ҳуқуқҳои Оператор:</h3>
      <p>
        Ба таври муваққатӣ қатъ кардани хизматрасонӣ барои гузаронидани корҳои
        профилактикӣ ё техникӣ бо огоҳкунии пешакӣ дар сомона;
      </p>
      <p>
        Дар сурати пардохт накардани ҳаққи хизматрасонӣ дастрасии Муштариро
        боздорад;
      </p>
      <p>
        Тағйир додани нархнома ва тарофаҳои амалкунанда бо огоҳкунии пешакӣ;
      </p>
      <p>
        Қатъ намудани хизматрасонӣ дар ҳолати вайронкунии шартҳои оферта аз
        ҷониби Муштарӣ.
      </p>

      <h3>2.3. Ӯҳдадориҳои Муштарӣ:</h3>
      <p>Нархи хизматҳоро сари вақт мутобиқи шартҳои оферта пардохт намояд;</p>
      <p>
        Дар бораи тағйир ёфтани маълумоти шахсӣ, суроға ё рақами телефон ба
        Оператор фавран хабар диҳад;
      </p>
      <p>
        Таҷҳизоти иҷорагирифтаро нигоҳ дорад ва дар ҳолати қатъ шудани хизматҳо
        баргардонад;
      </p>
      <p>Аз хизматрасониҳо танҳо ба мақсадҳои қонунӣ истифода барад;</p>
      <p>
        Аз ирсоли ахбороти ғайриқонунӣ, таҳқиромез ва зараровар худдорӣ намояд.
      </p>

      <h3>2.4. Ҳуқуқҳои Муштарӣ:</h3>
      <p>Дархости хаттӣ оид ба маълумоти ҳисоббаробаркуниҳо пешниҳод намояд;</p>
      <p>
        Бо огоҳкунии пешакии хаттӣ хизматҳоро муваққатан қатъ намояд (на зиёда
        аз 3 моҳ);
      </p>
      <p>
        Таҷҳизоти иҷорагириро харидорӣ намояд ё пас аз пардохти пурраи арзиш
        соҳиби он гардад.
      </p>

      <h2>3. НАРХИ ХИЗМАТҲО ВА ТАРТИБИ ҲИСОББАРОБАРКУНӢ</h2>

      <p>
        3.1. Нархи хизматҳо мувофиқи нархномаи амалкунандаи Оператор, ки дар
        сомонаи <a href="www.nets.tj">www.nets.tj</a> нашр мегардад, муқаррар
        карда мешавад.
      </p>

      <p>3.2. Пардохт метавонад бо роҳҳои зерин анҷом дода шавад:</p>
      <p>пули нақд ба хазинаи Оператор;</p>
      <p>интиқоли ғайринақдӣ ба суратҳисоби Оператор;</p>
      <p>
        воситаҳои электронии пардохт (бонкинги мобилӣ, ҳамёнҳои электронӣ ва
        ғ.).
      </p>

      <p>3.3. Давраи ҳисоббаробаркунӣ ҳар моҳи тақвимӣ муайян карда мешавад.</p>

      <p>
        3.4. Дар сурати набудани маблағ дар тавозуни Муштарӣ, Оператор ҳуқуқ
        дорад пешниҳоди хизматҳоро боздорад.
      </p>

      <p>
        3.5. Муштарӣ метавонад аз хизматрасонии «пардохти ваъдашуда» истифода
        барад тибқи шароите, ки дар сомонаи Оператор нишон дода шудаанд.
      </p>

      <p>
        3.6. Ҳамаи нархҳо бо асъори миллӣ (сомонӣ) бо назардошти андозҳои ААИ
        нишон дода мешаванд.
      </p>

      <h2>4. ТАРТИБИ ТАҒЙИР ДОДАН ВА ҚАТЪ КАРДАНИ ШАРТНОМА</h2>

      <p>
        4.1. Ҳамаи тағйирот ба оферта тавассути нашри версияи нав дар сомонаи{" "}
        <a href="www.nets.tj">www.nets.tj</a> амалӣ мегардад ва аз лаҳзаи нашр
        эътибор пайдо мекунад.
      </p>

      <p>
        4.2. Муштарӣ метавонад бо пешниҳоди дархости хаттӣ хизматрасониро қатъ
        намояд.
      </p>

      <p>
        4.3. Оператор ҳуқуқ дорад пешниҳоди хизматҳоро қатъ намояд, агар Муштарӣ
        шартҳои офертаро иҷро накунад.
      </p>

      <p>
        4.4. Агар Муштарӣ бо нархномаҳои тағйирёфта розӣ набошад, бояд дар
        давоми 5 рӯз огоҳномаи хаттӣ пешниҳод кунад. Дар акси ҳол, оферта ҳамчун
        қабулшуда ҳисобида мешавад.
      </p>

      <h2>5. ҶАВОБГАРИИ ТАРАФҲО</h2>

      <p>
        5.1. Барои иҷро накардан ё вайрон кардани ӯҳдадориҳо Тарафҳо тибқи
        қонунгузории амалкунандаи Ҷумҳурии Тоҷикистон ҷавобгар мебошанд.
      </p>

      <p>
        5.2. Муштарӣ барои мазмуни ахбороти ирсолнамуда, инчунин барои истифодаи
        суроғаи IP, ки ба ӯ вобаста аст, шахсан масъул мебошад.
      </p>

      <p>
        5.3. Барои таъхири пардохт, аз рӯзи баъди мӯҳлати пардохт, фоизи 0,5% аз
        маблағи қарз барои ҳар як рӯзи таъхир ҳисоб карда мешавад.
      </p>

      <h2>6. ФОРС-МАЖОР</h2>

      <p>
        6.1. Тарафҳо аз ҷавобгарӣ озоданд, агар иҷрои ӯҳдадориҳо бинобар таъсири
        қувваҳои беруна (сухтор, офати табиӣ, ҷанг, амалҳои давлатӣ ва ғ.)
        имконнопазир гардад.
      </p>

      <p>
        6.2. Тарафи дар чунин ҳолат қарордошта бояд дар давоми 15 рӯз дигар
        тарафро дар бораи фарорасӣ ё хотимаёбии чунин ҳолат огоҳ намояд.
      </p>

      <h2>7. ҲАЛЛИ БАҲСҲО</h2>

      <p>
        7.1. Ҳамаи баҳсҳо ва ихтилофҳо байни Тарафҳо тавассути гуфтушунид ҳал
        карда мешаванд.
      </p>

      <p>
        7.2. Агар мувофиқа ҳосил нашавад, баҳсҳо тибқи тартиби муқаррарнамудаи
        қонунгузории Ҷумҳурии Тоҷикистон дар суд ҳал карда мешаванд.
      </p>

      <h2>8. МУҚАРРАРОТИ ХОТИМАВӢ</h2>

      <p>
        8.1. Ба намудҳои иловагии хизматҳо, ки дар ин оферта қайд нашудаанд,
        шартҳои иловагӣ метавонад тавассути созишномаҳои алоҳида муайян карда
        шаванд.
      </p>

      <p>
        8.2. Муҳлати кафолатии таҷҳизоти пешниҳоднамудаи Оператор — 6 (шаш) моҳ
        мебошад.
      </p>

      <p>
        8.3. Оператор ҳуқуқ дорад дар ҳолати тағйирёбии меъёрҳои қонунгузорӣ ё
        нархномаҳои ҳатмӣ офертаро мутобиқ намояд ва муштариёнро на камтар аз 5
        рӯз пеш огоҳ созад.
      </p>

      <p>
        8.4. Муштарӣ бо қабул кардани ин оферта розигии худро барои коркарди
        маълумоти шахсӣ ва гирифтани иттилооти маркетингӣ аз ҷониби Оператор
        медиҳад.
      </p>

      <p>
        8.5. Ҳамаи маълумот дар бораи тарофаҳо, нархҳо ва шартҳои хизматрасонӣ
        дар сомонаи <a href="www.nets.tj">www.nets.tj</a> ва дар бланки
        шартномаи имзошудаи Муштарӣ нишон дода мешаванд.
      </p>

      <h2>9. МӮҲЛАТИ АМАЛИ ОФЕРТА</h2>

      <p>
        9.1. Ин оферта муҳлати номаҳдуд дорад ва то нашри версияи нав дар
        сомонаи <a href="www.nets.tj">www.nets.tj</a> амал мекунад.
      </p>

      <p>
        9.2. Қабули оферта тавассути имзои бланки шартнома ё оғози истифодаи
        хизматҳо маънои розигии пурра ва беэътирози Муштариро бо тамоми шартҳои
        мазкур дорад.
      </p>

      <p>
        ҶДММ «Нет Солюшенс»
        <br />
        РМА: 020047495
        <br />
        Ҷумҳурии Тоҷикистон, ш. Душанбе, кӯч. Т. Пулодӣ 41
        <br />
        Сомона: <a href="www.nets.tj">www.nets.tj</a>
        <br />
        Email: <a href="mailto:info@nets.tj">info@nets.tj</a>
      </p>
    </div>
  );

  return (
    <div className="oferta-page">
      <Menu />
      <div className="oferta-content-container">
        <div className="tabs">
          <button
            className={activeTab === "russian" ? "active" : ""}
            onClick={() => setActiveTab("russian")}
          >
            Русский
          </button>
          <button
            className={activeTab === "tajik" ? "active" : ""}
            onClick={() => setActiveTab("tajik")}
          >
            Тоҷикӣ
          </button>
        </div>
        <div className="content">
          {activeTab === "russian" ? russianText : tajikText}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default OfertaPage;
